// This file is automatically generated from ingestAssets.mjs
import * as React from 'react';
import IconContainer, { IconProps } from '../../../components/IconContainer';

export function AppStoreLogoBoldIcon(props: IconProps) {
	return (
		<IconContainer {...props}>
			{
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="100%"
					height="100%"
					fill="none"
					viewBox="0 0 32 32"
				>
					<path
						fill="currentColor"
						d="M31 20.515a1.5 1.5 0 0 1-1.5 1.5h-3.916l2.207 3.736a1.502 1.502 0 0 1-1.076 2.264 1.501 1.501 0 0 1-1.506-.738l-7.096-12.012a1.5 1.5 0 0 1 2.582-1.525l3.115 5.275h5.69a1.5 1.5 0 0 1 1.5 1.5Zm-13.856-1.5h-4.47L20.79 5.278a1.502 1.502 0 0 0-.519-2.07 1.5 1.5 0 0 0-2.063.544L16.5 6.64l-1.709-2.888a1.5 1.5 0 1 0-2.582 1.526l2.549 4.314-5.568 9.423H3.5a1.5 1.5 0 0 0 0 3h13.644a1.5 1.5 0 1 0 0-3Zm-9.29 5.208a1.5 1.5 0 0 0-2.054.528l-.591 1a1.5 1.5 0 1 0 2.582 1.526l.591-1a1.5 1.5 0 0 0-.528-2.054Z"
					/>
				</svg>
			}
		</IconContainer>
	);
}
